import React from "react";
import SectionHeading from "./SectionHeading";
import { LANDING } from "@/constants/testIds";

const POINTS = [
  "Founding economic alignment with platform formation",
  "Intended privileged access across mandates and co-investment",
  "Governance dialogue with the senior partnership",
  "Confidential, by-introduction process",
];

const AnchorPartner = ({ onRequestAccess }) => {
  return (
    <section
      id="anchor-partner"
      data-testid={LANDING.anchorPartner}
      className="relative py-32 lg:py-44 border-t border-[var(--kr-line-soft)]"
      style={{ background: "var(--kr-bg-2)" }}
    >
      <div className="max-w-[1480px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-16">
        <div className="lg:col-span-6">
          <SectionHeading
            index="14"
            label="Strategic Seed / Anchor Partner Opportunity"
            title={
              <>
                Selectively partnering with{" "}
                <span className="italic text-[var(--kr-gold)]">
                  foundational
                </span>{" "}
                capital.
              </>
            }
          />
        </div>
        <div className="lg:col-span-6 lg:pl-10">
          <p className="text-[var(--kr-text-muted)] text-[17px] leading-[1.85] max-w-[58ch] mb-10">
            Kellermann Reid &amp; Co. is in a selective engagement phase with a
            small number of strategic seed and anchor partners aligned with the
            long-term institutional build-out of the platform. Discussions are
            confidential, by introduction and conducted on documented terms
            appropriate for sophisticated investors.
          </p>
          <ul className="space-y-5 mb-12">
            {POINTS.map((p) => (
              <li
                key={p}
                className="flex items-start gap-4 text-[var(--kr-text)] text-[15.5px] leading-[1.65]"
              >
                <span
                  aria-hidden
                  className="font-mono-label text-[10px] text-[var(--kr-gold)] mt-1 select-none"
                >
                  +
                </span>
                <span>{p}</span>
              </li>
            ))}
          </ul>
          <button
            type="button"
            onClick={onRequestAccess}
            data-testid={LANDING.initiateDialogue}
            className="kr-btn-primary"
          >
            Initiate a Confidential Dialogue
            <span aria-hidden>→</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default AnchorPartner;
